
import { Component, Prop, Vue } from 'vue-property-decorator';
import { form19DataInfoType } from '@/types/Information/Form19';

import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";

@Component({
    components:{       
        CheckBox           
    }
})
export default class Form19Layout extends Vue {

    @Prop({required:true})
    result!: form19DataInfoType;

    dataReady = false;
    lawyerName = '';
    parties = '';

    mounted(){
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo(){

        if (this.result.withdrawingLawyerName == 'Other'){
            this.lawyerName = this.result.withdrawingLawyerNameOther;
        } else {
            this.lawyerName = this.result.withdrawingLawyerName;
        }

        this.parties = this.result.representingParties.join(', ');
           
    }

    
}

